import { render } from "./CinemaView.vue?vue&type=template&id=7c6d1141"
import script from "./CinemaView.vue?vue&type=script&lang=js"
export * from "./CinemaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__